// Composable for managing toast notifications
import { ref } from 'vue'

interface Toast {
  id: string
  title?: string
  message: string
  type: 'success' | 'warning' | 'error' | 'neutral'
  timeout?: number
}

const toasts = ref<Toast[]>([])

export function useToast() {
  const addToast = (message: string, type: 'success' | 'warning' | 'error' | 'neutral' = 'neutral', timeout: number = 10000, title?: string) => {
    // Check if a toast with the same message and title already exists
    const existingToast = toasts.value.find((toast) => toast.message === message && toast.title === title)

    if (existingToast) {
      // Return the existing toast ID instead of creating a duplicate
      return existingToast.id
    }

    const id = Date.now().toString() + Math.random().toString(36).substring(2, 9)
    const toast: Toast = {
      id,
      title,
      message,
      type,
      timeout,
    }
    toasts.value.push(toast)
    return id
  }

  const removeToast = (id: string) => {
    const index = toasts.value.findIndex((toast) => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clear = () => {
    toasts.value = []
  }

  return {
    toasts: toasts.value,
    addToast,
    removeToast,
    clear,
  }
}
